import { Container, Row, Col, Image } from "react-bootstrap";
import { FaGlobe, FaHeart, FaSyncAlt, FaSearch } from "react-icons/fa";
import "./MusicUpload.css";

function MusicUpload() {
  return (
    <section className="music-upload-cont">
      <Container>
        {/* Top Section */}
        <Row className="global-reach-section mb-5 align-items-center">
          <Col lg={5} className="reach-text-content">
            <h2 className="reach-title text-white mb-4">
              Upload <mark>Your Music</mark> <br />
              From Anywhere, <br />
              to Any Platform with <mark>FT Tunes</mark>
            </h2>
            <p className="reach-desc text-light">
              Streaming, downloads, YouTube monetisation and publishing,
              everything handled from anywhere. As the best music distribution
              company in India, you earn your money while we help you build your
              name.
            </p>
            {/* <p className="reach-desc text-light">
              Let your tracks be heard everywhere, ensuring your music gets the
              attention it deserves across all major streaming platforms.
            </p> */}
            {/* <button className="btn-upload-music mt-4">UPLOAD YOUR MUSIC</button> */}
          </Col>
          <Col lg={7} className="map-container position-relative">
            <div className="map-wrapper">
              <svg
                className="map-arcs"
                viewBox="0 0 800 400"
                preserveAspectRatio="xMidYMid meet"
              >
                <path d="M 400 200 Q 300 100 250 80" className="arc-path" />
                <path d="M 400 200 Q 450 80 500 80" className="arc-path" />
                <path d="M 400 200 Q 600 80 700 80" className="arc-path" />
                <path d="M 400 200 Q 300 250 250 250" className="arc-path" />
                <path d="M 400 200 Q 450 300 500 300" className="arc-path" />
                <path d="M 400 200 Q 600 250 700 250" className="arc-path" />
              </svg>

              <div className="upload-center">
                <div className="upload-icon-circle">
                  <div className="upload-pulse"></div>
                </div>
              </div>

              {/* Platform Markers */}
              <div className="platform-marker spotify">
                <img src="/Images/partner/Spotify.webp" alt="Spotify" />{" "}
                <span>Spotify</span>
              </div>
              <div className="platform-marker apple">
                <img src="/Images/partner/apple.webp" alt="Apple Music" />{" "}
                <span>Apple Music</span>
              </div>
              <div className="platform-marker youtube">
                <img src="/Images/partner/YouTube01.webp" alt="YouTube" />{" "}
                <span>YouTube</span>
              </div>
              <div className="platform-marker amazon">
                <img src="/Images/partner/amazon.webp" alt="Amazon Music" />{" "}
                <span>Amazon Music</span>
              </div>
              <div className="platform-marker deezer">
                <img src="/Images/partner/Deezer_logo.webp" alt="Deezer" />{" "}
                <span>Deezer</span>
              </div>
              <div className="platform-marker tiktok">
                <img src="/Images/partner/tiktok.webp" alt="TikTok" />{" "}
                <span>TikTok</span>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="divider-line my-5" />

        {/* Bottom Section */}
        <div className="fanbase-section mt-5 pt-4">
          <Row className="align-items-center">
            {/* Girl Image Column */}
            <Col lg={4} className="girl-img-col position-relative text-center">
              <div className="girl-image-container">
                <Image
                  src="/Images/ft-tunes-music-distribution.webp"
                  alt="Music Distribution"
                  fluid
                  className="girl-img-main"
                />
              </div>
            </Col>

            {/* Center Content Column */}
            <Col lg={5} className="fanbase-content text-start px-4">
              <h6 className="text-uppercase text-grow-fanbase mb-3">
               <mark>
                 GROW YOUR FANBASE
               </mark>
              </h6>
              <h2 className="fanbase-title text-white mb-4">
                Distribute <mark>Your Music</mark>{" "}
                Globally <br />
                with the Best Digital Music Distribution
              </h2>
              <p className="fanbase-desc text-light mb-4">
               Distribute your music globally on top platforms like Apple Music, JioSaavn, Spotify and more. Reach a worldwide audience and grow your fan base with seamless, efficient music distribution services.
              </p>

              <div className="stats-row d-flex justify-content-between align-items-center mt-5">
                <div className="stat-item text-start">
                  <div className="stat-icon-wrapper mb-2">
                    <span className="stat-icon-circle">
                      <FaGlobe />
                    </span>
                  </div>
                  <div className="stat-value fw-bold text-white fs-5">150+</div>
                  <div
                    className="stat-label text-light"
                    style={{ fontSize: "13px" }}
                  >
                    Platforms
                  </div>
                </div>
                <div className="stat-item text-start">
                  <div className="stat-icon-wrapper mb-2">
                    <span className="stat-icon-circle">
                      <FaHeart />
                    </span>
                  </div>
                  <div className="stat-value fw-bold text-white fs-5">UpTo 90%</div>
                  <div
                    className="stat-label text-light"
                    style={{ fontSize: "13px" }}
                  >
                    Royalty
                  </div>
                </div>
                <div className="stat-item text-start">
                  <div className="stat-icon-wrapper mb-2">
                    <span className="stat-icon-circle">
                      <FaSyncAlt />
                    </span>
                  </div>
                  <div className="stat-value fw-bold text-white fs-5">
                    Transparent
                  </div>
                  <div
                    className="stat-label text-light"
                    style={{ fontSize: "13px" }}
                  >
                    Earnings
                  </div>
                </div>
                <div className="stat-item text-start">
                  <div className="stat-icon-wrapper mb-2">
                    <span className="stat-icon-circle">
                      <FaSearch />
                    </span>
                  </div>
                  <div className="stat-value fw-bold text-white fs-5">24/7</div>
                  <div
                    className="stat-label text-light"
                    style={{ fontSize: "13px" }}
                  >
                    Support
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Column */}
            <Col lg={3} className="headphone-col text-center mt-4 mt-lg-0">
              <div className="headphone-container">
                <div className="headphone-image-wrapper">
                  {/* Using glowing_headphones.png as placeholder for the mic shown in mockup */}
                  <Image
                  src="https://images.pexels.com/photos/9154412/pexels-photo-9154412.jpeg"
                    // src="/Images/glowing_headphones.png"
                    alt="Recording equipment"
                    fluid
                    className="headphone-img"
                  />
                </div>
                <div className="waveform-container">
                  <div className="waveform-line purple"></div>
                  <div className="waveform-line blue"></div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default MusicUpload;
